import React from "react";
import "./App.css";
import Router from "./Routers";

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
